module.exports = __webpack_public_path__ + "static/img/0-3Company.89c0fe46.jpg";